"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _requestRates_TEXASTV = _interopRequireDefault(require("./includes/requestRates_TEXAS-TV.json"));
require("./css/lowratestv.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class LowRatesTV extends _react.Component {
  isNoCCProgram() {
    return false;
  }
  isLowPaymentProgram() {
    return true;
  }
  getRequestRates() {
    return _requestRates_TEXASTV.default;
  }
}
var _default = exports.default = LowRatesTV;